module.exports = __webpack_public_path__ + "static/media/sort-white.bd5f0c15.svg";